"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.generateSendMetricsImmediatelyForApp = exports.generateSendMetricsForApp = void 0;
var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/promise"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _pageHttpClient = _interopRequireDefault(require("@qualtrics/page-http-client"));
var _dataloader = _interopRequireDefault(require("dataloader"));
var sendMetricsImmediately = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(teamName, appName, actions) {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return _pageHttpClient.default.put('/metrics-proxy/', {
            teamName: teamName,
            appName: appName,
            actions: actions
          });
        case 3:
          _context.next = 8;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          console.error('Cannot send metrics data via metrics-proxy', _context.t0);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  }));
  return function sendMetricsImmediately(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var generateSendMetricsImmediatelyForApp = exports.generateSendMetricsImmediatelyForApp = function generateSendMetricsImmediatelyForApp(teamName, appName) {
  return {
    sendMetric: function sendMetric(action) {
      return sendMetricsImmediately(teamName, appName, [action]);
    },
    sendMetrics: function sendMetrics(actions) {
      return sendMetricsImmediately(teamName, appName, actions);
    }
  };
};
var generateSendMetricsForApp = exports.generateSendMetricsForApp = function generateSendMetricsForApp(teamName, appName) {
  var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
  var _generateSendMetricsI = generateSendMetricsImmediatelyForApp(teamName, appName),
    sendMetrics = _generateSendMetricsI.sendMetrics;
  var dataBatcher = new _dataloader.default(/*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(actions) {
      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return sendMetrics(actions);
          case 2:
            return _context2.abrupt("return", new _promise.default(function (res) {
              res((0, _map.default)(actions).call(actions, function () {
                return undefined;
              }));
            }));
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }(), {
    batchScheduleFn: function batchScheduleFn(callback) {
      return (0, _setTimeout2.default)(callback, timeout);
    },
    cache: false
  });
  return {
    sendMetric: function () {
      var _sendMetric = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(action) {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dataBatcher.load(action);
            case 2:
              return _context3.abrupt("return", new _promise.default(function (resolve) {
                return resolve();
              }));
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      function sendMetric(_x5) {
        return _sendMetric.apply(this, arguments);
      }
      return sendMetric;
    }(),
    sendMetrics: function () {
      var _sendMetrics = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee4(actions) {
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return dataBatcher.loadMany(actions);
            case 2:
              return _context4.abrupt("return", new _promise.default(function (resolve) {
                return resolve();
              }));
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      function sendMetrics(_x6) {
        return _sendMetrics.apply(this, arguments);
      }
      return sendMetrics;
    }()
  };
};
//# sourceMappingURL=sendMetrics.js.map